const NewMatchDetailRouter = [
  {
    path: '/new-match-detail/:unionMatchId',
    name: 'NewMatchDetail',
    meta: {
      // title: '赛事详情',
      mediator: () => import('@/fcl/tbs/controller/BaseMediator'),
      convertor: () => import('@/tbs/model/vo/NewMatchDetail'),
      translator: () => import('@/tbs/model/to/NewMatchDetail')
    },
    component: () => import('@/views/new-match-detail/index'),
    children: [
      {
        path: 'home',
        name: 'NewMatchDetailHome',
        component: () => import('@/views/new-match-detail/home'),
        meta: {
          properties: {
            title: '赛事详情',
          },
          mediator: () => import('@/fcl/tbs/controller/BaseMediator'),
          convertor: () => import('@/tbs/model/vo/NewMatchDetailHome'),
          translator: () => import('@/tbs/model/to/NewMatchDetail')
        }
      }
    ]
  },
  {
    path: '/match-detail/:unionMatchId/schedule',
    name: 'NewMatchDetailSchedule',
    component: () => import('@/views/new-match-detail/schedule'),
    meta: {
      title: '赛程表',
    }
  },
  {
    path: '/match-detail/:unionMatchId/standings',
    name: 'NewMatchDetailStandings',
    component: () => import('@/views/new-match-detail/standings'),
    meta: {
      title: '积分榜',
    }
  },
  {
    path: '/match-detail/:unionMatchId/entry-list',
    name: 'NewMatchDetailList',
    component: () => import('@/views/new-match-detail/entry-list'),
    meta: {
      title: '参赛名单',
    }
  },
  {
    path: '/match-detail/:unionMatchId/entry-team-roster',
    name: 'NewMatchDetailEntryTeamRoster',
    component: () => import('@/views/new-match-detail/entry-team-roster'),
    meta: {
      title: '球队名单',
    }
  },
  {
    path: '/match-detail/:unionMatchId/my-entry-list',
    name: 'NewMatchDetailMyEntryList',
    component: () => import('@/views/new-match-detail/my-entry-list'),
    meta: {
      title: '我的参赛',
    }
  },
  {
    path: '/match-detail/:unionMatchId/regulations',
    name: 'NewMatchDetailRegulations',
    component: () => import('@/views/new-match-detail/regulations'),
    meta: {
      title: '竞赛规程',
    }
  },
  {
    path: '/match-detail/:unionMatchId/news',
    name: 'NewMatchDetailNews',
    component: () => import('@/views/new-match-detail/news'),
    meta: {
      title: '新闻公告',
    }
  },
  {
    path: '/match-detail/:unionMatchId/player-list',
    name: 'NewMatchDetailPlayerList',
    component: () => import('@/views/new-match-detail/player-list'),
    meta: {
      title: '球员榜',
    }
  },
  {
    path: '/match-detail/:unionMatchId/draws',
    name: 'NewMatchDetailDraws',
    component: () => import('@/views/new-match-detail/draws'),
    meta: {
      title: '战表',
    }
  },
  {
    path: '/match-detail/:unionMatchId/real-time',
    name: 'NewMatchDetailRealTime',
    component: () => import('@/views/new-match-detail/real-time'),
    meta: {
      title: '签表',
    }
  }
]

export default NewMatchDetailRouter